/*
 * Copyright (c) 2023, tuanchauict
 */

package mono.common

/**
 * An object to contains all handling key-codes.
 */
object Key {
    const val KEY_ESC = 27
    const val KEY_SHIFT = 16
    const val KEY_ENTER = 13
    const val KEY_BACKSPACE = 8
    const val KEY_DELETE = 46
    const val KEY_ARROW_LEFT = 37
    const val KEY_ARROW_UP = 38
    const val KEY_ARROW_RIGHT = 39
    const val KEY_ARROW_DOWN = 40
    const val KEY_A = 65
    const val KEY_C = 67
    const val KEY_D = 68
    const val KEY_L = 76
    const val KEY_R = 82
    const val KEY_T = 84
    const val KEY_V = 86
    const val KEY_X = 88
    const val KEY_Z = 90
}
